import { observable, computed, makeObservable, action, toJS } from 'mobx';

let app = {};

export class CategoriesStore {
  constructor(store) {
    makeObservable(this);
    app.store = store;
    this.dataSource = app.store.api.categories;
  }

  @observable
  items = [];

  @observable
  loading = {
    status: false,
    message: undefined,
  };

  @computed
  get is_loading() {
    return this.loading.status;
  }

  @computed
  get all_categories() {
    return this.items ? toJS(this.items) : [];
  }

  @action
  setLoadingStatus = (status) => {
    this.loading.status = status;
  };

  @action
  setCategories = (items) => {
    this.items = items;
  };

  @action
  fetchCategories = async () => {
    this.loading.status = true;

    try {
      const categories = await this.dataSource.list();

      // Sort categories by their sort property
      const sortedCategories = categories.sort((a, b) => {
        // Handle cases where sort might be undefined, null, or a string
        const sortOrderA = a.sort ? parseInt(a.sort, 10) : 999;
        const sortOrderB = b.sort ? parseInt(b.sort, 10) : 999;

        // Handle NaN cases (if parseInt fails)
        const finalSortA = isNaN(sortOrderA) ? 999 : sortOrderA;
        const finalSortB = isNaN(sortOrderB) ? 999 : sortOrderB;

        return finalSortA - finalSortB;
      });

      this.setCategories(sortedCategories);
    } catch (e) {
      console.error('Error fetching categories:', e);
      // Set empty categories array on error to avoid UI issues
      this.setCategories([]);
    } finally {
      this.setLoadingStatus(false);
    }
  };
}

export default CategoriesStore;
